import { useEffect, useMemo } from 'react'
import { useLocation } from 'react-router-dom'

export default function PolicyContactPage() {
  const location = useLocation()
  const sections = useMemo(
    () => [
      { id: 'hang-hoa', title: 'I. Thông tin về hàng hóa, dịch vụ' },
      { id: 'dieu-kien-giao-dich', title: 'II. Thông tin về điều kiện giao dịch chung' },
      { id: 'thanh-toan', title: 'III. Thông tin về phương thức thanh toán' },
      { id: 'bao-mat', title: 'IV. Thông tin về bảo vệ thông tin cá nhân' },
      { id: 'khieu-nai', title: 'V. Cơ chế giải quyết khiếu nại, tranh chấp' },
    ],
    []
  )

  useEffect(() => {
    const hash = location.hash?.replace('#', '').trim()
    if (!hash) {
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
      return
    }

    const el = document.getElementById(hash)
    if (!el) return
    el.scrollIntoView({ behavior: 'smooth', block: 'start' })
  }, [location.hash])

  return (
    <div className="w-full lg:max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 pt-6 pb-24">
      <div className="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-800 rounded-2xl shadow-sm p-5 sm:p-7">
        <div className="flex flex-col gap-3">
          <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 dark:text-gray-100">Thông tin website</h1>
          <p className="text-sm sm:text-base text-gray-600 dark:text-gray-300">
            Trang này tổng hợp các thông tin bắt buộc/khuyến nghị khi vận hành website có giao dịch trực tuyến và khi thực hiện hồ sơ Thông báo/Đăng ký với Bộ Công Thương.
          </p>
        </div>

        <div className="mt-6 grid grid-cols-1 lg:grid-cols-12 gap-6">
          <section className="order-1 lg:order-2 lg:col-span-8">
            <div className="space-y-6">
              <div id="hang-hoa" className="scroll-mt-24">
                <div className="rounded-xl border border-gray-200 dark:border-gray-800 p-4 sm:p-5">
                  <div className="text-lg font-semibold text-gray-900 dark:text-gray-100">I. Thông tin về hàng hóa, dịch vụ</div>
                  <div className="mt-3 text-sm text-gray-700 dark:text-gray-200 space-y-3">
                    <div className="text-gray-600 dark:text-gray-300">
                      Website cung cấp <span className="font-semibold">sản phẩm/dịch vụ số</span> (key/mã kích hoạt/tài khoản hoặc thông tin truy cập tuỳ gói). Vì vậy <span className="font-semibold">không có vận chuyển vật lý</span>.
                    </div>

                    <div>
                      <div className="font-semibold">Thông tin hiển thị trên website cho từng sản phẩm/gói</div>
                      <ul className="list-disc pl-5 mt-2 space-y-1">
                        <li>Tên sản phẩm.</li>
                        <li>Thông tin mô tả: cơ chế, ưu/nhược điểm, mô tả gói (nếu được nhập).</li>
                        <li>Danh sách gói (variant): tên gói, thời hạn (ngày hoặc vĩnh viễn), giá bán.</li>
                        <li>Giá sau giảm (nếu có) được hiển thị trực tiếp khi áp dụng giảm giá theo gói/hạng người dùng.</li>
                        <li>Tồn kho hiển thị dạng “Còn lại: …” và trạng thái “Hết hàng” khi kho bằng 0.</li>
                        <li>Link hướng dẫn sử dụng/cài đặt (nếu gói/sản phẩm có cấu hình link).</li>
                      </ul>
                    </div>

                    <div>
                      <div className="font-semibold">Thuế/phí & chi phí phát sinh</div>
                      <ul className="list-disc pl-5 mt-2 space-y-1">
                        <li>Hiện hệ thống <span className="font-semibold">không thu phí vận chuyển</span> và <span className="font-semibold">không có COD</span>.</li>
                        <li>Hiện tại không có cơ chế tính thêm “phí dịch vụ/phí duy trì” ở bước thanh toán.</li>
                        <li>Giá hiển thị trên website là <span className="font-semibold">giá cuối cùng</span> khách cần thanh toán (không có phụ phí phát sinh).</li>
                        <li>Hiện tại <span className="font-semibold">không xuất hóa đơn VAT</span>.</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

              <div id="dieu-kien-giao-dich" className="scroll-mt-24">
                <div className="rounded-xl border border-gray-200 dark:border-gray-800 p-4 sm:p-5">
                  <div className="text-lg font-semibold text-gray-900 dark:text-gray-100">II. Thông tin về điều kiện giao dịch chung</div>
                  <div className="mt-3 text-sm text-gray-700 dark:text-gray-200 space-y-4">
                    <div>
                      <div className="font-semibold">1) Điều kiện giao dịch</div>
                      <ul className="list-disc pl-5 mt-2 space-y-1">
                        <li>Người mua cần đăng nhập để mua hàng/nạp tiền và sử dụng các tiện ích.</li>
                        <li>Giao dịch mua sử dụng <span className="font-semibold">số dư ví</span> trong tài khoản.</li>
                        <li>Số lượng mua tối đa mỗi lần: <span className="font-semibold">tối đa 10</span> hoặc theo tồn kho hiển thị (tùy mức nào nhỏ hơn).</li>
                      </ul>
                    </div>

                    <div>
                      <div className="font-semibold">2) Quy trình đặt hàng (mua sản phẩm)</div>
                      <ul className="list-disc pl-5 mt-2 space-y-1">
                        <li>Chọn sản phẩm → chọn gói (variant) → chọn số lượng → xác nhận mua.</li>
                        <li>Nếu số dư không đủ, hệ thống gợi ý <span className="font-semibold">Nạp tiền ngay</span> và tự điền số tiền thiếu.</li>
                        <li>Sau khi mua thành công, hệ thống hiển thị key/mã giao dịch và link hướng dẫn (nếu được cấu hình cho gói/sản phẩm).</li>
                      </ul>
                    </div>

                    <div>
                      <div className="font-semibold">3) Quy trình giao nhận</div>
                      <ul className="list-disc pl-5 mt-2 space-y-1">
                        <li>
                          <span className="font-semibold">Giao tự động</span>: hệ thống trả key ngay sau khi thanh toán thành công (nếu là gói có kho key).
                        </li>
                        <li>
                          <span className="font-semibold">Giao thủ công</span>: hệ thống trả về <span className="font-semibold">mã giao dịch/mã đơn</span>; bạn gửi mã này cho CSKH (Chat Support) để nhận key.
                        </li>
                        <li className="text-gray-600 dark:text-gray-300">Lưu ý: Với gói giao thủ công, hệ thống có tin nhắn tự động hướng dẫn bạn chờ khoảng 5–10 phút trong khung chat.</li>
                      </ul>
                    </div>

                    <div>
                      <div className="font-semibold">4) Chính sách đổi trả / hoàn tiền</div>
                      <div className="mt-2 text-gray-600 dark:text-gray-300">
                        Áp dụng khi dịch vụ được đánh giá là lỗi nghiêm trọng, lệch đáng kể so với nội dung hiển thị trên website.
                      </div>
                      <ul className="list-disc pl-5 mt-2 space-y-1">
                        <li>Nếu lỗi xảy ra ngay từ đầu: hoàn <span className="font-semibold">100%</span> số tiền.</li>
                        <li>Nếu lỗi phát sinh trong quá trình sử dụng: hoàn theo <span className="font-semibold">thời gian còn lại</span> của gói/dịch vụ.</li>
                        <li>Hình thức hoàn: khách nhắn qua Telegram cung cấp <span className="font-semibold">STK</span> → shop chuyển khoản số tiền hoàn.</li>
                        <li className="text-gray-600 dark:text-gray-300">Cách tính “theo thời gian còn lại” hiện không được hệ thống tự động tính trong code (hoàn theo thoả thuận/đối soát thủ công qua CSKH).</li>
                      </ul>
                    </div>

                    <div>
                      <div className="font-semibold">5) Giới hạn trách nhiệm</div>
                      <ul className="list-disc pl-5 mt-2 space-y-1">
                        <li>Người mua có trách nhiệm lưu lại key/mã giao dịch, không chia sẻ thông tin cho bên thứ ba.</li>
                        <li>Hệ thống có thể tạm ngưng cung cấp khi gói hết kho key/tồn kho (hiển thị "Hết hàng").</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

              <div id="thanh-toan" className="scroll-mt-24">
                <div className="rounded-xl border border-gray-200 dark:border-gray-800 p-4 sm:p-5">
                  <div className="text-lg font-semibold text-gray-900 dark:text-gray-100">III. Thông tin về phương thức thanh toán</div>
                  <div className="mt-3 text-sm text-gray-700 dark:text-gray-200 space-y-3">
                    <div>
                      <div className="font-semibold">1) Nạp tiền (chuyển khoản ngân hàng / VietQR)</div>
                      <ul className="list-disc pl-5 mt-2 space-y-1">
                        <li>Nạp tối thiểu: <span className="font-semibold">20.000đ</span>.</li>
                        <li>Hệ thống tạo mã QR (VietQR) kèm nội dung chuyển khoản <span className="font-semibold">DH...</span> để đối soát.</li>
                        <li>Đơn nạp có thời hạn xử lý: <span className="font-semibold">15 phút</span>. Quá thời gian này đơn được xem là hết hạn.</li>
                        <li>Mỗi tài khoản tối đa <span className="font-semibold">2</span> giao dịch nạp đang xử lý cùng lúc.</li>
                        <li>Sau khi chuyển khoản thành công, hệ thống tự cập nhật số dư trong khoảng <span className="font-semibold">1–2 phút</span> (tùy ngân hàng).</li>
                      </ul>
                    </div>

                    <div>
                      <div className="font-semibold">2) Thanh toán mua hàng</div>
                      <ul className="list-disc pl-5 mt-2 space-y-1">
                        <li>Thanh toán bằng <span className="font-semibold">số dư ví</span> trên tài khoản sau khi nạp.</li>
                        <li>Giá hiển thị là giá cuối cùng sau giảm giá (nếu có) theo gói và/hoặc hạng người dùng.</li>
                        <li className="text-gray-600 dark:text-gray-300">Website hiện không triển khai COD, ví điện tử riêng, hoặc cổng thanh toán thẻ trực tiếp; chỉ có nạp qua chuyển khoản VietQR rồi dùng số dư ví để mua.</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

              <div id="bao-mat" className="scroll-mt-24">
                <div className="rounded-xl border border-gray-200 dark:border-gray-800 p-4 sm:p-5">
                  <div className="text-lg font-semibold text-gray-900 dark:text-gray-100">IV. Thông tin về bảo vệ thông tin cá nhân</div>
                  <div className="mt-3 text-sm text-gray-700 dark:text-gray-200 space-y-4">
                    <div>
                      <div className="font-semibold">2.6.1. Mục đích và phạm vi thu thập</div>
                      <div className="mt-2 text-gray-600 dark:text-gray-300">
                        Website có thể thu thập các thông tin phục vụ việc đăng ký/đăng nhập và vận hành giao dịch: email, username, họ tên (nếu có), SĐT (nếu có), nội dung hỗ trợ (chat), lịch sử nạp/mua, số dư ví và thông tin kỹ thuật cơ bản (thiết bị/trình duyệt, nhật ký truy cập).
                      </div>
                      <ul className="list-disc pl-5 mt-2 space-y-1">
                        <li>Xác thực tài khoản và đảm bảo an toàn đăng nhập.</li>
                        <li>Xử lý giao dịch nạp tiền/mua hàng, đối soát và cung cấp nội dung số.</li>
                        <li>Liên hệ hỗ trợ khi có sự cố, khiếu nại/hoàn tiền (nếu phát sinh).</li>
                        <li>Gửi thông báo liên quan đơn hàng/tài khoản; không gửi quảng cáo làm phiền nếu bạn không yêu cầu.</li>
                      </ul>
                    </div>

                    <div>
                      <div className="font-semibold">2.6.2. Phạm vi sử dụng thông tin</div>
                      <ul className="list-disc pl-5 mt-2 space-y-1">
                        <li>Thông tin được dùng nội bộ để vận hành dịch vụ, hỗ trợ khách hàng và xử lý giao dịch.</li>
                        <li>Có thể chia sẻ cho nhà cung cấp hạ tầng/kỹ thuật (lưu trữ cơ sở dữ liệu, máy chủ) để website hoạt động.</li>
                        <li>Có thể chia sẻ thông tin cần thiết cho đơn vị tạo/hiển thị QR (VietQR) nhằm tạo mã thanh toán, không nhằm mục đích khác.</li>
                        <li>Khi có yêu cầu hợp pháp từ cơ quan nhà nước có thẩm quyền, website có thể cung cấp thông tin theo quy định pháp luật.</li>
                      </ul>
                    </div>

                    <div>
                      <div className="font-semibold">2.6.3. Thời gian lưu trữ thông tin</div>
                      <div className="mt-2 text-gray-600 dark:text-gray-300">
                        Thông tin tài khoản và lịch sử giao dịch được lưu trong thời gian cần thiết để cung cấp dịch vụ, đối soát và giải quyết khiếu nại. Khi người dùng yêu cầu xóa tài khoản, dữ liệu sẽ được xóa/ẩn theo quy trình hệ thống; một số dữ liệu đối soát có thể được lưu thêm trong thời hạn phù hợp theo quy định pháp luật và sao lưu kỹ thuật.
                      </div>
                    </div>

                    <div>
                      <div className="font-semibold">2.6.4. Những người hoặc tổ chức có thể được tiếp cận với thông tin cá nhân</div>
                      <ul className="list-disc pl-5 mt-2 space-y-1">
                        <li>Chủ website (cá nhân) và/hoặc người được ủy quyền quản trị hệ thống để vận hành và hỗ trợ.</li>
                        <li>Nhà cung cấp hạ tầng kỹ thuật (dịch vụ lưu trữ, cơ sở dữ liệu, máy chủ).</li>
                        <li>Đơn vị trung gian hiển thị QR (VietQR) trong phạm vi cần thiết để tạo mã QR.</li>
                        <li>Cơ quan nhà nước có thẩm quyền trong trường hợp có yêu cầu theo pháp luật.</li>
                      </ul>
                    </div>

                    <div>
                      <div className="font-semibold">2.6.5. Địa chỉ của đơn vị thu thập và quản lý thông tin cá nhân</div>
                      <ul className="list-disc pl-5 mt-2 space-y-1">
                        <li>Đơn vị quản lý: Chủ website Tạp hóa nội dung số (cá nhân).</li>
                        <li>Địa chỉ: Không công khai (hỗ trợ trực tuyến).</li>
                        <li>Số điện thoại: 0394352614.</li>
                        <li>Email: luongquocthai.thaigo.2003@gmail.com.</li>
                        <li>Dữ liệu được lưu trữ trên hệ thống website và hạ tầng lưu trữ/đám mây phục vụ vận hành (cơ sở dữ liệu/máy chủ).</li>
                      </ul>
                    </div>

                    <div>
                      <div className="font-semibold">2.6.6. Phương tiện và công cụ để người dùng tiếp cận và chỉnh sửa dữ liệu cá nhân của mình</div>
                      <ul className="list-disc pl-5 mt-2 space-y-1">
                        <li>Người dùng có thể xem/cập nhật thông tin tại trang Hồ sơ (Profile) trên website (nếu có trường thông tin tương ứng).</li>
                        <li>Người dùng có quyền yêu cầu chỉnh sửa/hủy thông tin cá nhân hoặc yêu cầu hỗ trợ xóa dữ liệu thông qua Chat Support hoặc nhóm Telegram.</li>
                        <li>Người dùng có thể tự xóa tài khoản tại trang Hồ sơ (mục “Xóa tài khoản vĩnh viễn”).</li>
                      </ul>
                    </div>

                    <div>
                      <div className="font-semibold">2.6.7. Cam kết bảo mật thông tin cá nhân khách hàng</div>
                      <ul className="list-disc pl-5 mt-2 space-y-1">
                        <li>Không bán/cho thuê/chia sẻ thông tin cá nhân cho bên thứ ba vì mục đích thương mại trái phép.</li>
                        <li>Áp dụng các biện pháp bảo vệ hợp lý: phân quyền truy cập, bảo vệ tài khoản, mã hóa kết nối (HTTPS) và kiểm soát truy cập hệ thống.</li>
                        <li>Trong trường hợp phát hiện sự cố rò rỉ hoặc tấn công, website sẽ thực hiện cô lập/khắc phục và thông báo trong phạm vi phù hợp.</li>
                        <li>Người dùng có trách nhiệm bảo mật mật khẩu, không chia sẻ thông tin đăng nhập cho người khác.</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

              <div id="khieu-nai" className="scroll-mt-24">
                <div className="rounded-xl border border-gray-200 dark:border-gray-800 p-4 sm:p-5">
                  <div className="text-lg font-semibold text-gray-900 dark:text-gray-100">V. Cơ chế giải quyết khiếu nại, tranh chấp</div>
                  <div className="mt-3 text-sm text-gray-700 dark:text-gray-200 space-y-3">
                    <div>
                      <div className="font-semibold">1) Tiếp nhận khiếu nại</div>
                      <ul className="list-disc pl-5 mt-2 space-y-1">
                        <li>Ưu tiên: nhắn <span className="font-semibold">Chat Support</span> trên website.</li>
                        <li>Ngoài ra: nhắn nhóm Telegram hỗ trợ.</li>
                      </ul>
                    </div>

                    <div>
                      <div className="font-semibold">2) Thông tin cần cung cấp để xử lý nhanh</div>
                      <ul className="list-disc pl-5 mt-2 space-y-1">
                        <li>Mã giao dịch/mã đơn (hiển thị trong lịch sử giao dịch).</li>
                        <li>Tên sản phẩm + gói đã mua.</li>
                        <li>Mô tả lỗi, ảnh chụp/video (nếu có).</li>
                      </ul>
                    </div>

                    <div>
                      <div className="font-semibold">3) Thời hạn xử lý</div>
                      <div className="mt-2 text-gray-600 dark:text-gray-300">
                        Mình sẽ phản hồi sớm nhất có thể; với đơn giao thủ công, hệ thống có tin nhắn tự động hướng dẫn bạn chờ khoảng 5–10 phút.
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </section>

          <aside className="order-2 lg:order-1 lg:col-span-4">
            <div className="sticky top-24">
              <div className="rounded-xl border border-gray-200 dark:border-gray-800 bg-gray-50 dark:bg-gray-950 p-4">
                <div className="text-sm font-semibold text-gray-900 dark:text-gray-100">Mục lục</div>
                <div className="mt-3 flex flex-col gap-2">
                  {sections.map(s => (
                    <a
                      key={s.id}
                      href={`#${s.id}`}
                      className="text-sm text-amber-700 dark:text-blue-300 hover:underline"
                    >
                      {s.title}
                    </a>
                  ))}
                </div>
              </div>

              <div className="mt-4 rounded-xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 p-4">
                <div className="text-sm font-semibold text-gray-900 dark:text-gray-100">Liên hệ nhanh</div>
                <div className="mt-3 text-sm text-gray-700 dark:text-gray-200 space-y-2">
                  <div>
                    <div className="font-medium">Telegram hỗ trợ</div>
                    <div className="text-gray-600 dark:text-gray-300">Nhóm Telegram: https://t.me/+_KxbPXTAu7AzYjg1</div>
                  </div>
                  <div>
                    <div className="font-medium">Zalo hỗ trợ</div>
                    <div className="text-gray-600 dark:text-gray-300">Zalo: <a href="https://zalo.me/0794174833" target="_blank" rel="noopener noreferrer" className="text-amber-700 dark:text-blue-300 hover:underline">https://zalo.me/0794174833</a></div>
                  </div>
                  <div>
                    <div className="font-medium">Chat Support</div>
                    <div className="text-gray-600 dark:text-gray-300">Bấm biểu tượng chat ở góc màn hình để gửi yêu cầu hỗ trợ.</div>
                  </div>
                  <div>
                    <div className="font-medium">Thông tin chủ sở hữu</div>
                    <div className="text-gray-600 dark:text-gray-300">Lương Quốc Thái</div>
                    <div className="text-gray-600 dark:text-gray-300">SĐT: 0394352614</div>
                    <div className="text-gray-600 dark:text-gray-300">MST cá nhân: 079203027622</div>
                    <div className="text-gray-600 dark:text-gray-300">Địa chỉ: Không công khai (hỗ trợ trực tuyến)</div>
                  </div>
                </div>
              </div>
            </div>
          </aside>
        </div>
      </div>
    </div>
  )
}
